module.exports = __webpack_public_path__ + "img/sushi.b9d4ad10.png";